module.exports = __webpack_public_path__ + "static/media/fanyuvo_logo.d91534ce.png";